<template>
  <v-layout>
    <v-flex>
      <v-row align="center" no-gutters>
        <v-col class="text-left ml-n6" cols="12" md="6">
          <v-breadcrumbs :items="subNavs"></v-breadcrumbs>
        </v-col>
        <v-col class="text-right"  cols="12" md="6">
          <ActionButtons
            @doClose="doClose"
            :actionBtnSettings="actionBtnSettings"
          >
          </ActionButtons>
        </v-col>
      </v-row>

      <v-card class="pa-6 mt-3">
        <v-card-title>
          Shipping Mark
          <v-spacer></v-spacer>
          <BookingStatusLabel :status="booking.status" :small="false" :statuses="statuses"></BookingStatusLabel>
        </v-card-title>
        <v-card-subtitle>
          {{booking.shipping_mark}}
          <v-spacer></v-spacer>
        </v-card-subtitle>

        <v-card-text class="text--primary">
          <v-row no-gutters>
            <v-col cols="12" sm="12" md="6">
              <v-list two-line>
                <v-list-item>
                  <v-list-item-icon>
                    <v-icon>
                      mdi-account-outline
                    </v-icon>
                  </v-list-item-icon>

                  <v-list-item-content>
                    <v-list-item-title>{{booking.client_name}}</v-list-item-title>
                    <v-list-item-subtitle>Bill To</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

              </v-list>
            </v-col>
            <v-col cols="12" sm="12" md="6">
              <v-list two-line>
                <v-list-item>
                  <v-list-item-icon>
                    <v-icon>
                      mdi-calendar-clock
                    </v-icon>
                  </v-list-item-icon>

                  <v-list-item-content>
                    <v-list-item-title>{{ booking.created_at | moment("MMM D, YYYY h:mm A") }}</v-list-item-title>
                    <v-list-item-subtitle>Created Date</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

              </v-list>
            </v-col>
            <v-col cols="12" sm="12" md="6">
              <v-list two-line>
                <v-list-item>
                  <v-list-item-icon>
                    <v-icon>
                      mdi-face-agent
                    </v-icon>
                  </v-list-item-icon>

                  <v-list-item-content>
                    <v-list-item-title>{{booking.sales_agent_name}}</v-list-item-title>
                    <v-list-item-subtitle>Sales Agent</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

              </v-list>
            </v-col>
            <v-col cols="12" sm="12" md="6">
              <v-list two-line>
                <v-list-item>
                  <v-list-item-icon>
                    <v-icon>
                      mdi-calendar
                    </v-icon>
                  </v-list-item-icon>

                  <v-list-item-content>
                    <v-list-item-title v-if="booking.target_delivery_date">{{booking.target_delivery_date | moment("MMM D, YYYY")}}</v-list-item-title>
                    <v-list-item-title v-if="!booking.target_delivery_date">-</v-list-item-title>
                    <v-list-item-subtitle>Estimated Delivery Date</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>

              </v-list>
            </v-col>
          </v-row>

          <!-- <div class="text-h6 mt-6 mb-2">
            Items
          </div> -->
          <v-data-table
            class="mt-12"
            :headers="headers"
            :items="booking.items"
            hide-default-footer
            :items-per-page="1000"
            loading-text="Loading Items..."
            no-data-text="No Items"
            ref="table">

            <template v-slot:[`item.status`]="{ item }">
              <BookingStatusLabel :status="item.status" :small="true" :statuses="statuses"></BookingStatusLabel>
            </template>

            <template v-slot:[`item.qty`]="{ item }">
              {{ formatNumber(item.qty) }}
            </template>

            <template v-slot:[`item.item_length`]="{ item }">
              {{ formatNumber(item.item_length) }}
            </template>

            <template v-slot:[`item.item_width`]="{ item }">
              {{ formatNumber(item.item_width) }}
            </template>

            <template v-slot:[`item.item_height`]="{ item }">
              {{ formatNumber(item.item_height) }}
            </template>

            <template v-slot:[`item.cbm`]="{ item }">
              {{ formatNumber(item.cbm) }}
            </template>

            <template v-slot:[`item.kg`]="{ item }">
              {{ formatNumber(item.kg) }}
            </template>

            <template v-slot:body.append>
              <tr class="sm-hidden">
                <td class="text-right"><strong>TOTAL</strong></td>
                <td class="text-center">
                  <strong>{{ formatNumber(totalQty) }}</strong>
                </td>
                <td class="text-center" v-if="isShipmentForSea(booking.shipment_type)">
                  <strong>{{ formatNumber(totalKg) }}</strong>
                </td>
                <td class="text-center" v-if="isShipmentForSea(booking.shipment_type)">
                  <!-- <strong>{{ formatNumber(totalLength) }}</strong> -->
                </td>
                <td class="text-center" v-if="isShipmentForSea(booking.shipment_type)">
                  <!-- <strong>{{ formatNumber(totalWidth) }}</strong> -->
                </td>
                <td class="text-center" v-if="isShipmentForSea(booking.shipment_type)">
                  <!-- <strong>{{ formatNumber(totalHeight) }}</strong> -->
                </td>
                <td class="text-center">
                  <strong v-if="isShipmentForSea(booking.shipment_type)">{{ formatNumber(totalCbm) }}</strong>
                  <strong v-if="!isShipmentForSea(booking.shipment_type)">{{ formatNumber(totalKg) }}</strong>
                </td>
                <td></td>
              </tr>
            </template>


          </v-data-table>
        </v-card-text>
        <v-card-title class="mb-4 mt-5">
          History
          <v-spacer></v-spacer>
        </v-card-title>
        <v-card-text>
          <v-timeline
            dense
            align-top
            v-for="(timeline, index) in booking.histories"
            :key="index"
          >
            <v-timeline-item
              :color="statusColor(timeline.status)"
              small
              dense
              class="mt-n6"
            >
              <strong>{{ timeline.title }}</strong>
              <div class="text-caption">
                <span v-if="timeline.description">{{ timeline.description }}<br></span>
                {{ timeline.created_at | moment("MMM D, YYYY h:mm A") }}
              </div>
            </v-timeline-item>
          </v-timeline>
        </v-card-text>
      </v-card>

      <SnackBar :snackbarDetails="snackbarDetails"></SnackBar>

      <Loader :loading="loading"></Loader>
    </v-flex>
  </v-layout>
</template>

<script>
  import { mapGetters } from "vuex";
  import SnackBar from '@/components/snackbar/SnackBar.vue'
  import Loader from '@/components/Loader.vue'
  import BookingStatusLabel from '@/components/BookingStatusLabel.vue'
  import ActionButtons from '@/components/ActionButtons.vue'

  export default {
    name: 'ClientBookingView',
    data: () => ({
      mnus: [],
      mnusItem: [],
      id: null,
      loading: false,
      loadingHistory: false,
      menuEstDeliveryDate: false,
      histories: [],
      history: {
        title: '',
        description: ''
      },
      actionBtnSettings: {
        edit: 0,
        save: 0,
        refresh: 0,
        close: 1,
        print: 0,
        send: 0,
        save_and_print: 0,
        save_disabled: false,
        close_disabled: false,
        print_disabled: false,
        save_and_print_disabled: false
      },
      subNavs: [
        {
          text: 'Bookings',
          disabled: false,
          exact: true,
          to: {
            name: 'bookings'
          },
        },
        {
          text: 'View Booking',
          disabled: true,
          href: 'breadcrumbs_link_2',
        },
      ],
      error:{
        show: false,
        status: '',
        error: '',
        messages: {}
      },
      snackbarDetails: {
        color: 'sb-success',
        msg: '',
        show: false
      },
      booking: {
        id: '',
        client: '',
        sales_agent: '',
        created_date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        target_delivery_date: '',
        items: [],
        histories: []
      },
      items: [],
      statuses: [],
      headers: [],
      saveChangesEnable: false
    }),
    watch: {
    },
    computed: {
      ...mapGetters(['formatNumber', 'formatNumberAmount', 'formatNumberAmountNoComma', 'getStatusColor', 'getMyInitial', 'forSea']),
      forUpdate: function(){
        return this.id ? true : false
      },
      totalQty: function(){
        let qty = 0

        this.booking.items.forEach(obj => {
          qty = qty + Number(this.formatNumberAmountNoComma(this.$numeral, obj.qty))
        })
        return qty
      },
      totalCbm: function(){
        let cbm = 0
        this.booking.items.forEach(obj => {
          cbm = cbm + Number(this.formatNumberAmountNoComma(this.$numeral, obj.cbm))
        })
        return cbm
      },
      totalKg: function(){
        let kg = 0
        this.booking.items.forEach(obj => {
          kg = kg + Number(this.formatNumberAmountNoComma(this.$numeral, obj.kg))
        })
        return kg
      },
      totalLength: function(){
        let item_length = 0
        this.booking.items.forEach(obj => {
          item_length = item_length + Number(this.formatNumberAmountNoComma(this.$numeral, obj.item_length))
        })
        return item_length
      },
      totalWidth: function(){
        let item_width = 0
        this.booking.items.forEach(obj => {
          item_width = item_width + Number(this.formatNumberAmountNoComma(this.$numeral, obj.item_width))
        })
        return item_width
      },
      totalHeight: function(){
        let item_height = 0
        this.booking.items.forEach(obj => {
          item_height = item_height + Number(this.formatNumberAmountNoComma(this.$numeral, obj.item_height))
        })
        return item_height
      }
    },
    methods: {
      statusColor (statusId){
        return this.getStatusColor(statusId, this)
      },
      checkShipmentType (){
        if(this.isShipmentForSea(this.booking.shipment_type)){
          this.headers = [
            {
              text: 'Item',
              align: 'start',
              value: 'description',
              sortable: false
            },
            {
              text: 'Qty',
              align: 'center',
              value: 'qty',
              sortable: false,
              width: 90
            },
            {
              text: 'KG',
              align: 'center',
              value: 'kg',
              sortable: false,
              width: 90
            },
            {
              text: 'Length',
              align: 'center',
              value: 'item_length',
              sortable: false,
              width: 90
            },
            {
              text: 'Width',
              align: 'center',
              value: 'item_width',
              sortable: false,
              width: 90
            },
            {
              text: 'Height',
              align: 'center',
              value: 'item_height',
              sortable: false,
              width: 90
            },
            {
              text: 'CBM',
              align: 'center',
              value: 'cbm',
              sortable: false,
              width: 120
            },
            {
              text: 'Status',
              align: 'center',
              value: 'status',
              sortable: false,
              width: 110,
            },
          ]
        }else{
          this.headers = [
            {
              text: 'Item',
              align: 'start',
              value: 'description',
              sortable: false
            },
            {
              text: 'Qty',
              align: 'center',
              value: 'qty',
              sortable: false,
              width: 120
            },
            {
              text: 'KG',
              align: 'center',
              value: 'kg',
              sortable: false,
              width: 120
            },
            {
              text: 'Status',
              align: 'center',
              value: 'status',
              sortable: false,
              width: 120,
            },
          ]
        }
      },
      isShipmentForSea (shipment_type){
        return this.forSea(shipment_type, this)
      },
      doClose (){
        this.$router.push({ name: 'bookings' })
      },
      gotoBookings () {
        this.$router.push({ name: 'bookings' })
      },
      getBooking () {
        this.loading = true
        let self = this
        this.$http.plain.get('bookings/'+this.id)
          .then(response => {
            this.booking = response.data
            this.checkShipmentType()

            setTimeout(function(){
              self.getBookingHistory()
            }, 100);

          })
          .catch(error => {
            console.log(error);
          })
          .then(function () {
            self.loading = false
          })
      },
      getBookingHistory () {
        this.loadingHistory = true
        let self = this
        this.$http.plain.get('booking-history/'+this.id)
          .then(response => {
            this.histories = response.data
          })
          .catch(error => {
            console.log(error);
          })
          .then(function () {
            self.loadingHistory = false
          })
      },
      getDefaultData () {
        let self = this
        this.$http.plain.get('/default-data?booking_statuses=true')
          .then(response => {
            this.statuses = response.data.booking_statuses
          })
          .catch(error => {
            console.log(error);
          })
      },
      showMessage(msg, color){
        this.snackbarDetails = {
          color: color,
          msg: msg,
          show: true
        }
      },
      clear () {
        Object.keys(this.history).forEach(key => {
          this.history[key] = ''
        })
      },
    },
    mounted() {
      this.id = this.$route.params.id
      this.getBooking()
      this.getDefaultData()
    },
    components: {
      BookingStatusLabel,
      SnackBar,
      Loader,
      ActionButtons
    }
  }
</script>
